import { render, staticRenderFns } from "./HistoriqueInventairePage.vue?vue&type=template&id=2320fc0f&scoped=true&"
import script from "./HistoriqueInventairePage.vue?vue&type=script&lang=js&"
export * from "./HistoriqueInventairePage.vue?vue&type=script&lang=js&"
import style0 from "./HistoriqueInventairePage.vue?vue&type=style&index=0&id=2320fc0f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320fc0f",
  null
  
)

export default component.exports